import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import AccessForbidden from "../views/AccessForbidden.vue";

const routes = [
  {
    path: "/",
    name: "base",
    component: HomeView,
  },
  {
    path: "/home",
    name: "amrHome",
    component: HomeView,
  },
  {
    path: "/loading",
    name: "loading",
    component: HomeView,
  },
  {
    path: "/error/:code",
    name: "error",
    component: HomeView,
    props: { errorCode: 99999 },
  },
  {
    path: "/forbidden/:code?",
    name: "access_forbidden",
    component: AccessForbidden,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
